import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "./Button";
import { RiCloseLargeLine } from "react-icons/ri";
import { HiOutlineMenu } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

const navItems = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "About Us", id: "about_us" },
  { label: "Contact", id: "contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuVariants = {
    hidden: { x: "100%", opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 80 },
    },
    exit: { x: "100%", opacity: 0, transition: { duration: 0.3 } },
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-colors duration-500 bg-white text-[#020046] ${
        scrolled ? "shadow-lg" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center space-x-2 h-full p-2">
            <img
              src="logo.png"
              alt="Logo"
              className="h-full cursor-pointer"
              onClick={() => {
                navigate("/home");
              }}
            />
            <span
              className="font-bold text-xl cursor-pointer"
              onClick={() => {
                navigate("/home");
              }}
            >
              Glow PCOD
            </span>
          </div>

          <div className="hidden md:flex space-x-6">
            {navItems.map(({ label, id }) => (
              <a
                key={id}
                onClick={() => {
                  navigate(`/${id}`);
                }}
                className="relative font-medium hover:text-pink-600 transition cursor-pointer left-to-right-link"
              >
                {label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex">
            <Button
              onClick={() => navigate("/appointment")}
              label={"Book Appointment"}
            />
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setMenuOpen(true)}
              className="cursor-pointer"
            >
              <HiOutlineMenu size={20} />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="md:hidden fixed top-0 right-0 h-full w-full bg-white p-6 z-50"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={menuVariants}
          >
            <div className="flex justify-end">
              <button
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer"
              >
                <RiCloseLargeLine />
              </button>
            </div>

            <div className="flex flex-col space-y-6 mt-10">
              {navItems.map(({ label, id }) => (
                <a
                  key={id}
                  onClick={() => {
                    navigate(`/${id}`);
                    setMenuOpen(false);
                  }}
                  className="text-lg hover:text-pink-400 transition"
                >
                  {label}
                </a>
              ))}

              <Button
                label={"Book Appointment"}
                onClick={() => {
                  setMenuOpen(false);
                  navigate("/appointment");
                }}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
